import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-observed-field-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './observed-field-alert.component.html',
  styleUrl: './observed-field-alert.component.scss',
})
export class ObservedFieldAlertComponent {
  @Input() text: string = 'Es necesario subsanar este campo';
}
